import { theme } from "@chakra-ui/pro-theme";
import { extendTheme, theme as baseTheme } from "@chakra-ui/react";
import chroma from "chroma-js";
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import "../../font/New Science/NewScience.css";
const eChargeCyan = chroma("#00bcde");
const cardBlue = chroma("#003366");
const makeColorScheme = (color) => ({
    50: color.brighten(2.75).hex(),
    100: color.brighten(2.2).hex(),
    200: color.brighten(1.65).hex(),
    300: color.brighten(1.1).hex(),
    400: color.brighten(0.55).hex(),
    500: color.hex(),
    600: color.darken(0.7).hex(),
    700: color.darken(1.4).hex(),
    800: color.darken(2.1).hex(),
    900: color.darken(2.75).hex()
});
export const customTheme = extendTheme(theme, {
    components: {
        Button: {
            baseStyle: {
                fontWeight: 'bold'
            },
            sizes: {
                md: {
                    py: 2.5
                },
                xl: {
                    h: '55px',
                    fontSize: 'lg',
                    px: '30px',
                    py: '15px',
                    "border-radius": "30px"
                },
            },
            variants: {
                base: (props) => ({
                    color: props.colorScheme + ".900",
                    bg: props.colorScheme + ".500",
                    _hover: {
                        bg: props.colorScheme + ".400"
                    }
                })
            }
        },
        Heading: {
            sizes: {
                h6: {
                    fontFamily: "body",
                    fontSize: ["md"],
                    fontWeight: "medium",
                    mb: 1
                },
                h5: {
                    fontFamily: "body",
                    fontSize: ["md", "lg"],
                    fontWeight: "bold",
                    mb: 1
                },
                h4: {
                    fontFamily: "body",
                    fontSize: ["lg", "xl"],
                    fontWeight: "bold",
                    mb: 1
                },
                h3: {
                    fontSize: ["1xl", "3xl", "4xl"],
                    fontWeight: "black"
                },
                h2: {
                    fontSize: ["2xl", "4xl", "5xl"],
                    fontWeight: "black"
                }
            }
        }
    },
    colors: Object.assign(Object.assign({}, baseTheme.colors), { brand: makeColorScheme(eChargeCyan), "cardBlue": makeColorScheme(cardBlue) }),
    fonts: {
        heading: `"New Science", sans-serif`,
        body: `'Open Sans', sans-serif`,
    },
    fontWeights: {
        normal: 300,
        medium: 400,
        semibold: 500,
        bold: 600,
        black: 700
    },
    shadows: {
        glow: '0 0 2rem 0 rgba(' + eChargeCyan.alpha(0.5).rgba() + ')'
    },
    styles: {
        global: {
            ".raw-html": {
                a: {
                    color: "brand.500",
                    textDecoration: "underline"
                },
                ul: {
                    marginLeft: "2em",
                    marginBottom: "1em"
                },
                p: {
                    marginBottom: "1em"
                }
            }
        }
    }
});
